import { render, staticRenderFns } from "./CarVignettesEditForm.vue?vue&type=template&id=205b7fd4&scoped=true&"
import script from "./CarVignettesEditForm.vue?vue&type=script&lang=js&"
export * from "./CarVignettesEditForm.vue?vue&type=script&lang=js&"
import style0 from "./CarVignettesEditForm.vue?vue&type=style&index=0&id=205b7fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205b7fd4",
  null
  
)

export default component.exports